import { pilot } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';
import { Uuid } from '~/types/Uuid';

type Request = {
  tag: Uuid;
  pilotDocumentId: number;
};

type Response = {
  words: { word: string; id: Nullable<number> }[];
};

export const getCLMeDocumentContent = async ({
  pilotDocumentId,
  tag,
}: Request): Promise<Response> =>
  await pilot.get(`/version/clme/${pilotDocumentId}/words`, {
    params: { tag },
  });
